<template>
    <a
        :href="currentFile.src"
        download
        target="_blank"
        class="w-full h-auto flex items-center justify-center text-lg lg:text-2xl p-6 lg:min-h-64"
        :style="{
            color: player.textColor,
        }"
    >
        <DownloadTrayIcon class="mr-4 h-12 w-12" />
        {{ $t("r_player.download_file") }}
    </a>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { DownloadTrayIcon } from "@easy/ui/icons";

export default {
    name: "FileDownload",
    computed: {
        ...mapState("player/view", ["player"]),
        ...mapGetters("player/view", ["currentFile"]),
    },
    components: {
        DownloadTrayIcon,
    },
};
</script>
